import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled, useTheme } from '@mui/material';
import { getImageKitUrlFrom } from '../utils';

const StyledProfilePhoto = styled('img')(() => ({
    borderRadius: '50%',
    margin: '0 auto',
    objectFit: 'cover'
}));

const StyledDefaultProfileBox = styled(Box)(() => ({
    borderRadius: '50%',
    margin: '0 auto',
    background: '#134C03',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
}));

interface ProfilePhotoProps {
    url: string;
    size: string;
    initials: string;
}
export function ProfilePhoto({ url, size, initials }: ProfilePhotoProps): JSX.Element {
    const theme = useTheme();
    return (
        <>
            {url ? (
                <StyledProfilePhoto
                    src={getImageKitUrlFrom(url)}
                    alt="candidate-picture"
                    sx={{ width: size, height: size, marginRight: '20px' }}
                />
            ) : (
                <StyledDefaultProfileBox sx={{ width: size, height: size, marginRight: '20px' }}>
                    <Typography variant="h3" fontWeight={800} color={theme.palette.common.white}>
                        {initials}
                    </Typography>
                </StyledDefaultProfileBox>
            )}
        </>
    );
}
